module.exports = __webpack_public_path__ + "static/media/img_ana.9c395956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images_annamnese/img_ana.jpg
// module id = ./src/statics/images_annamnese/img_ana.jpg
// module chunks = 0